import React, { createContext, useContext } from "react";

import useSurveyStore from "@/surveys/hooks/useSurveyStore";

type SurveyStoreValue = ReturnType<typeof useSurveyStore>;

const SurveyStoreContext = createContext<SurveyStoreValue | null>(null);

export function useSurveyStoreContext(): SurveyStoreValue {
  const ctx = useContext(SurveyStoreContext);
  if (!ctx) {
    throw new Error(
      "useSurveyStoreContext must be used within SurveyStoreProvider",
    );
  }
  return ctx;
}

export default function SurveyStoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const store = useSurveyStore();
  return (
    <SurveyStoreContext.Provider value={store}>
      {children}
    </SurveyStoreContext.Provider>
  );
}
